import { CSSProperties, useState } from "react";

import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

import { CopyContentIcon } from "@dotnet/telematics-design-system";

import Button from "../Button/Button";
import { ButtonSizes } from "../Button/types";
import Tooltip from "../Tooltip/Tooltip";

interface CopyButtonProps {
  size: ButtonSizes;
  copiedValue: string;
  buttonCustomStyle?: CSSProperties;
  testId?: string;
}

const CopyButton = ({
  size,
  copiedValue,
  buttonCustomStyle,
  testId
}: CopyButtonProps) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  return (
    <CopyToClipboard text={copiedValue} onCopy={() => setCopied(true)}>
      <Tooltip
        title={copied ? t("Button##copied") : t("Button##copy to clipboard")}
        size="medium"
        placement="top"
        slotProps={{ transition: { onExited: () => setCopied(false) } }}
      >
        <Button
          data-testid={testId ?? "copy-button"}
          style={buttonCustomStyle}
          variant="iconOnly"
          size={size}
          color="secondary"
          icon={
            <CopyContentIcon
              style={{ width: "16px", height: "16px", padding: "4px" }}
            />
          }
        />
      </Tooltip>
    </CopyToClipboard>
  );
};

export default CopyButton;
